(function () {
    'use strict';

    function loadBodyPixModel() {
        var bodyPixScript = document.createElement('script');
        bodyPixScript.src = 'https://cdn.jsdelivr.net/npm/@tensorflow-models/body-pix@2.2.0/dist/body-pix.js';
        document.head.appendChild(bodyPixScript);
    }

    function loadBodyPixLibrary() {
        var tfScript = document.createElement('script');
        tfScript.src = 'https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@3.10.0/dist/tf.js';
        tfScript.onload = loadBodyPixModel;
        document.head.appendChild(tfScript);
    }
    loadBodyPixLibrary();

    angular.module('thankview.recorder')
        .factory('webcamService', ['httpProgress', '$rootScope', '$timeout', '$q', '$document', '$window', 'logEventService', function (httpProgress, $rootScope, $timeout, $q, $document, $window, logEventService) {
            const webcamService = {};
            let clonedRes = [];
            const resolutions = [
                {
                    label: '1080p',
                    value: { width: { exact: 1920 }, height: { exact: 1080 } },
                    selected: true,
                    supported: true,
                },
                {
                    label: '720p',
                    value: { width: { exact: 1280 }, height: { exact: 720 } },
                    supported: true,
                },
                {
                    label: '480p',
                    value: { width: { exact: 640 }, height: { exact: 480 } },
                    supported: true,
                },
            ];

            const internalResolutions = [
                {
                    label: 'low',
                },
                {
                    label: 'medium',
                },
                {
                    label: 'high',
                },
                {
                    label: 'full',
                    selected: true,
                },
            ];

            let cameraDevices = [];
            let audioDevices = [];
            let selectedResolution = resolutions[0].value;
            let selectedInternalResolution = internalResolutions.find((res) => res.selected).label;
            let selectedCameraId;
            let selectedAudioId;
            let previewElem;
            let cameraStream;
            let recorder;
            let startRecordingTime;
            let recordingTime = 0; // track the current recording time in seconds
            const recordingLimit = 300; // max recording length in seconds
            let recordedData = [];
            let startCountdownTime;
            // options: https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints
            const mediaParams = { audio: true };
            // options: https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder/MediaRecorder
            const recorderParams = {};
            let webmMimeType = true;
            let startOver = false;
            let bgImg = '';
            let backgroundBlurAmount = '';
            let backgroundImg;
            let canvas;
            let ctx;
            let net;
            let recording = false;
            let combinedStream;
            let videoId = null;

            let backgroundCanvas;
            let backgroundCtx;
            let backgroundImageData = null;

            let testCanvas;
            let testCtx;
            let personImageData = null;

            /*
             * Initialize on page load. Detect the current permissions
             * granted by the user.
             * @param {string} elemId : id of html element to render the recorder
             */
            webcamService.init = async (elemId) => {
                previewElem = $document[0].getElementById(elemId).querySelector('video');
                // Create canvas and context
                canvas = $document[0].getElementById(elemId).querySelector('canvas');
                ctx = canvas.getContext('2d', { willReadFrequently: true });
                backgroundCanvas = $document[0].createElement('canvas');
                testCanvas = $document[0].createElement('canvas');

                // Load the BodyPix model
                // net = await bodyPix.load();
                net = await bodyPix.load({
                    architecture: 'MobileNetV1',
                    outputStride: 16,
                    multiplier: 0.75,
                    quantBytes: 2,
                });

                // bind to even in the case devices change
                $window.navigator.mediaDevices.ondevicechange = webcamService.getDevices;
            };

            // function to set the background image
            webcamService.setImage = async (img) => {
                try {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    bgImg = img;
                    backgroundBlurAmount = '';
                    backgroundImg = new Image();
                    backgroundImg.src = bgImg;
                    backgroundCtx = backgroundCanvas.getContext('2d', { willReadFrequently: true });
                    backgroundCtx.drawImage(backgroundImg, 0, 0, backgroundCanvas.width, backgroundCanvas.height);
                    backgroundImageData = null;

                    previewElem.style.display = 'none';

                    console.log('backgroundCanvas', backgroundCanvas.width, backgroundCanvas.height);
                    webcamService.initRecorder();
                } catch (error) {
                    console.error('Error converting image to Base64:', error);
                }
            };

            function resetResolutions() {
                resolutions.length = 0;
                clonedRes.forEach((res) => {
                    if (res.value === selectedResolution) {
                        res.selected = true;
                    } else {
                        res.selected = false;
                    }
                });
                resolutions.push(...clonedRes);
            }

            // function to set the background blur
            webcamService.setBlur = (val) => {
                backgroundBlurAmount = val;
                bgImg = '';
                previewElem.style.display = val === 0 ? 'block' : 'none';

                if (val === 0) {
                    resetResolutions();
                }

                webcamService.initRecorder();
            };

            function blurEffect(canvasInner, previewElement, personSegmentation, backgroundBlurAmt) {
                const edgeBlurAmount = 3;
                const flipHorizontal = false;

                // Draw the image with the background blurred onto the canvas.
                bodyPix.drawBokehEffect(canvasInner, previewElement, personSegmentation, backgroundBlurAmt, edgeBlurAmount, flipHorizontal);
            }

            function renderBackgroundImg(personSegmentation) {
                const canvasWidth = 640;
                const canvasHeight = 480;

                const segmentationData = personSegmentation.data;
                const tempData = personImageData.data;

                if (backgroundImageData === null) {
                    console.log('test bg');
                    backgroundCtx.drawImage(backgroundImg, 0, 0, canvasWidth, canvasHeight);
                    backgroundImageData = backgroundCtx.getImageData(0, 0, canvasWidth, canvasHeight);
                }

                const backgroundData = backgroundImageData.data;

                // create a new blank image
                const newImageData = ctx.createImageData(canvasWidth, canvasHeight);
                const data = newImageData.data;

                // copy the user or the background to the new image
                for (let i = 0; i < data.length; i += 4) {
                    if (segmentationData[i / 4] !== 0) {
                        data[i] = tempData[i];
                        data[i + 1] = tempData[i + 1];
                        data[i + 2] = tempData[i + 2];
                        data[i + 3] = 255;
                    } else {
                        data[i] = backgroundData[i];
                        data[i + 1] = backgroundData[i + 1];
                        data[i + 2] = backgroundData[i + 2];
                        data[i + 3] = backgroundData[i + 3];
                    }
                }
                ctx.putImageData(newImageData, 0, 0);
            }

            let cachedPersonSegmentation;
            async function processFrame() {
                testCtx = testCanvas.getContext('2d', { willReadFrequently: true });
                testCtx.drawImage(previewElem, 0, 0, testCanvas.width, testCanvas.height);

                personImageData = testCtx.getImageData(0, 0, testCanvas.width, testCanvas.height);
                cachedPersonSegmentation = await net.segmentPerson(personImageData, {
                    flipHorizontal: false,
                    internalResolution: selectedInternalResolution,
                    segmentationThreshold: 0.5,
                });

                if (previewElem.readyState === 4) {
                    if (bgImg) {
                        renderBackgroundImg(cachedPersonSegmentation);
                    } else {
                        blurEffect(canvas, previewElem, cachedPersonSegmentation, backgroundBlurAmount);
                    }
                    // Request the next frame
                    if (recording) {
                        requestAnimationFrame(processFrame);
                    }
                }
            }

            // Define the event handler function
            function loadedDataHandler() {
                // Wait for the video metadata to load, then set canvas size
                if (['', 0].includes(backgroundBlurAmount) && bgImg === '') return;
                processFrame();
            }

            function applyVirtualBackground() {
                const width = 640;
                const height = 480;
                Object.assign(previewElem, { width, height });
                Object.assign(canvas, { width, height });
                Object.assign(testCanvas, { width, height });
                Object.assign(backgroundCanvas, { width, height });
                clonedRes = [...resolutions];

                const filteredResolutions = clonedRes
                    .filter((resolution) => resolution.label === '480p')
                    .map((resolution) => ({ ...resolution, selected: true })); // Create a deep clone of each resolution object
                // Assign the filtered values back to the 'resolutions' array
                resolutions.length = 0; // Clear the original array
                resolutions.push(...filteredResolutions);
                // Add the event listener with the defined handler
                previewElem.addEventListener('loadeddata', loadedDataHandler);
            }

            /*
             * Initialize the media recorder if possible.
             * This prompts the user to access their camera and microphone.
             */
            webcamService.initRecorder = () => {
                // don't reinitialize the recorder
                if (recorder && ([''].includes(backgroundBlurAmount || !backgroundImg))) {
                    $rootScope.$broadcast('recorder-camera-activated');
                    return;
                }
                if (selectedResolution) {
                    if (bgImg || !['', 0].includes(backgroundBlurAmount)) {
                        mediaParams.video = resolutions.find((resolution) => resolution.label === '480p').value;
                    } else {
                        mediaParams.video = selectedResolution;
                    }
                }
                if (selectedCameraId) {
                    mediaParams.video.deviceId = selectedCameraId;
                }
                if (selectedAudioId) {
                    mediaParams.audio = { deviceId: selectedAudioId };
                }

                if (recorder && recorder.state === 'inactive' && (bgImg || !['', 0].includes(backgroundBlurAmount)) && clonedRes.length) {
                    resetResolutions();
                }

                $window.navigator.mediaDevices.getUserMedia(mediaParams).then((stream) => {
                    cameraStream = stream;

                    // set the stream to our video element
                    // so the user can see themselves
                    previewElem.srcObject = stream;
                    previewElem.play();
                    recording = true;
                    if (bgImg || !['', 0].includes(backgroundBlurAmount)) {
                        applyVirtualBackground();
                    }

                    if (typeof $window.MediaRecorder.isTypeSupported === 'function') {
                        if ($window.MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                            recorderParams.mimeType = 'video/webm;codecs=vp9';
                        } else if ($window.MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
                            recorderParams.mimeType = 'video/webm;codecs=h264';
                        } else if ($window.MediaRecorder.isTypeSupported('video/webm')) {
                            recorderParams.mimeType = 'video/webm';
                        } else if ($window.MediaRecorder.isTypeSupported('video/mp4')) {
                            recorderParams.mimeType = 'video/mp4';
                            webmMimeType = false;
                        }
                    } else {
                        // test for webm support
                        var testVideo = $document[0].createElement('video');
                        if (testVideo.canPlayType && testVideo.canPlayType('video/webm; codecs="vp8, vorbis"') !== '') {
                            recorderParams.mimeType = 'video/webm';
                            webmMimeType = true;
                        } else {
                            recorderParams.mimeType = 'video/mp4';
                            webmMimeType = false;
                        }
                    }

                    console.log('mime type', recorderParams.mimeType);

                    // create a recorder object from the video stream
                    if (bgImg || !['', 0].includes(backgroundBlurAmount)) {
                        combinedStream = new MediaStream();
                        const videoTrack = canvas.captureStream().getVideoTracks()[0];
                        const audioTrack = stream.getAudioTracks()[0];
                        combinedStream.addTrack(videoTrack);
                        combinedStream.addTrack(audioTrack);
                        recorder = new $window.MediaRecorder(combinedStream, recorderParams);
                    } else {
                        recorder = new $window.MediaRecorder(stream, recorderParams);
                    }

                    // capture data while recording to create a blob
                    // when recording is complete
                    recorder.ondataavailable = (e) => {
                        if (e.data && e.data.size > 0) {
                            recordedData.push(e.data);
                        }
                    };

                    // create blob object and upload to our server
                    recorder.onstop = () => {
                        let recordedBlob = null;
                        // prevent the video from processing if user clicks on Start Over button
                        if (startOver) {
                            // Clear recordedData after creating the Blob
                            recordedData = [];
                            recordedBlob = new $window.Blob(recordedData, {
                                type: recorderParams.mimeType,
                            });
                            startOver = false;
                            // reset value
                            return;
                        }

                        recordedBlob = new $window.Blob(recordedData, {
                            type: recorderParams.mimeType,
                        });

                        if (webmMimeType) {
                            // webm videos don't have the correct metadata
                            // use below functions to add the duration to the video
                            webcamService.getBlobDuration(recordedBlob).then((duration) => {
                                $window.ysFixWebmDuration(recordedBlob, duration * 1000, (fixedBlob) => {
                                    webcamService.uploadRecording(fixedBlob, duration, videoId);
                                });
                            });
                        } else {
                            webcamService.uploadRecording(recordedBlob, '', videoId);
                        }
                    };

                    // record errors in bugsnag
                    recorder.onerror = function (event) {
                        const err = event.error;

                        if ($window.Bugsnag) {
                            Bugsnag.notify(new Error('webcam recorder error'), (e) => {
                                e.addMetadata('custom', { name: err.name, error: err });
                            });
                        }

                        console.log('recorder error', err);
                    };

                    // fetch devices after the user has granted access
                    if (cameraDevices.length === 0 && audioDevices.length === 0) {
                        webcamService.getDevices();
                    }

                    // show state where the camera is activated
                    $rootScope.$broadcast('recorder-camera-activated');
                }).catch((err) => {
                    if (err.name === 'AbortError') {
                        // some problem occurred which prevented the device from being used.
                    } else if (err.name === 'NotAllowedError') {
                        // permission denied in browser
                    } else if (err.name === 'NotFoundError') {
                        // no camera or microphone found
                    } else if (err.name === 'NotReadableError') {
                        // a hardware error occurred at the operating system, or browser
                        // which prevented access to the device.
                    } else if (err.name === 'OverconstrainedError') {
                        // constraints can not be satisfied by the devices
                        // if the current resolution isn't supported, let's try the next option
                        let lowerResOption;
                        angular.forEach(resolutions, (resolution, i) => {
                            console.log(resolution, selectedResolution);
                            if (resolution.value === selectedResolution && resolutions[i + 1]) {
                                resolution.supported = false;
                                lowerResOption = resolutions[i + 1];
                            }
                        });
                        if (lowerResOption) {
                            webcamService.setResolution(lowerResOption);
                            return;
                        }
                    } else if (err.name === 'SecurityError') {
                        // User media support is disabled on the document
                    } else if (err.name === 'TypeError') {
                        // the list of constraints specified is empty, or has all constraints set to false
                    } else {
                        // other unknown error
                    }

                    console.log('device error', err);

                    // for all errors, let's currently show that the state
                    // where the camera is denied
                    $rootScope.$broadcast('recorder-camera-denied');

                    if ($window.Bugsnag) {
                        Bugsnag.notify(new Error('webcam device error'), (e) => {
                            e.addMetadata('custom', { name: err.name, error: err });
                        });
                    }
                });
            };

            /*
             * Return resolution options for the video.
             */
            webcamService.getResolutions = () => resolutions;

            webcamService.getInternalResolutions = () => internalResolutions;

            /*
             * Set the resolution for the video.
             * @param {Object} resolution : resolution to change the camera
             */
            webcamService.setResolution = (resolution) => {
                console.log('set', resolution);

                // set which resolution is selected
                resolutions.map((option) => {
                    option.selected = false;
                    return option;
                });
                resolution.selected = true;
                selectedResolution = resolution.value;

                if ((bgImg || !['', 0].includes(backgroundBlurAmount)) && clonedRes.length) {
                    resetResolutions();
                }

                webcamService.resetRecorder();
                webcamService.initRecorder();
            };

            webcamService.setInternalResolution = (resolution) => {
                // set which resolution is selected
                internalResolutions.map((option) => {
                    option.selected = false;
                    return option;
                });
                resolution.selected = true;
                selectedInternalResolution = resolution.label;

                webcamService.resetRecorder();
                webcamService.initRecorder();
            };

            /*
             * Get the available video and audio devices the user
             * has given us permission
             */
            webcamService.getDevices = () => {
                console.log('get devices');

                cameraDevices = [];
                audioDevices = [];

                $window.navigator.mediaDevices.enumerateDevices().then((devices) => {
                    angular.forEach(devices, (device) => {
                        if (device.kind === 'videoinput') {
                            if (selectedCameraId && selectedCameraId === device.deviceId) {
                                device.selected = true;
                            }
                            cameraDevices.push(device);
                        }
                        if (device.kind === 'audioinput') {
                            if (selectedAudioId && selectedAudioId === device.deviceId) {
                                device.selected = true;
                            }
                            audioDevices.push(device);
                        }
                    });

                    // if the user has not selected a camera or audio option
                    // the first option is automatically selected
                    if (!selectedCameraId && cameraDevices[0]) {
                        cameraDevices[0].selected = true;
                    }
                    if (!selectedAudioId && audioDevices[0]) {
                        audioDevices[0].selected = true;
                    }

                    console.log('devices', cameraDevices, audioDevices);

                    $rootScope.$broadcast('recorder-devices-detected', cameraDevices, audioDevices);
                });
            };

            /*
             * Set the camera option for the recorder
             * @param {Object} device : device to change the camera
             */
            webcamService.setCamera = (device) => {
                // set which device is selected
                cameraDevices.map((option) => {
                    option.selected = false;
                    return option;
                });
                device.selected = true;
                selectedCameraId = device.deviceId;

                webcamService.resetRecorder();
                webcamService.initRecorder();
            };

            /*
             * Set the audio option for the recorder
             * @param {Object} device : device to change the audio
             */
            webcamService.setAudio = (device) => {
                // set which device is selected
                audioDevices.map((option) => {
                    option.selected = false;
                    return option;
                });
                device.selected = true;
                selectedAudioId = device.deviceId;

                webcamService.resetRecorder();
                webcamService.initRecorder();
            };

            /*
             * Start the recording process by starting the
             * 3 second countdown
             */
            webcamService.startRecorder = () => {
                $rootScope.$broadcast('recorder-start-countdown');

                startCountdownTime = null;
                startRecordingTime = null;
                recordingTime = 0;

                $window.requestAnimationFrame(webcamService.countdown);
            };

            /*
             * Animate the countdown. This runs on the next
             * animation frame available.
             * @param {float} time : current time of the animation frame
             */
            webcamService.countdown = (time) => {
                if (!startCountdownTime) {
                    $window.requestAnimationFrame(webcamService.countdown);
                    startCountdownTime = time;
                    return;
                }

                const totalTime = time - startCountdownTime;

                if (totalTime < 3000) {
                    $window.requestAnimationFrame(webcamService.countdown);
                    $rootScope.$broadcast('recorder-countdown', totalTime);
                } else {
                    $rootScope.$broadcast('recorder-end-countdown');

                    $timeout(function () {
                        $rootScope.$broadcast('recorder-start-recording');
                        recorder.start();

                        $window.requestAnimationFrame(webcamService.trackRecordingTime);
                    }, 250);
                }

                $rootScope.$apply();
            };


            webcamService.setVideoId = function (id) {
                videoId = id;
            };

            webcamService.getVideoId = function () {
                return videoId;
            };

            /*
             * Track how long the user has been recording for
             * @param {integer} time : current time in milliseconds
             */
            webcamService.trackRecordingTime = (time) => {
                if (!startRecordingTime) {
                    $window.requestAnimationFrame(webcamService.trackRecordingTime);
                    startRecordingTime = time;
                    return;
                }

                recordingTime = Math.round((time - startRecordingTime) / 1000);

                $rootScope.$broadcast('recording', recordingTime, recordingLimit);

                if (recorder && recorder.state === 'recording') {
                    $window.requestAnimationFrame(webcamService.trackRecordingTime);
                }
            };

            /*
             * Stop the recording process. Show the uploading state and
             * set the upload percentage to 0.
             */
            webcamService.stopRecorder = (id) => {
                recorder.stop();
                if (bgImg || !['', 0].includes(backgroundBlurAmount)) {
                    recording = false;
                    // Later, when you want to remove the event listener
                    previewElem.removeEventListener('loadeddata', loadedDataHandler);
                }
                $rootScope.$broadcast('recorder-uploading', 0, id);
            };

            /*
             * Stops all streams and resets the recorder.
             */
            webcamService.resetRecorder = () => {
                const streamType = (bgImg || !['', 0].includes(backgroundBlurAmount)) ? combinedStream : cameraStream;
                if (streamType) {
                    streamType.getTracks().forEach((track) => {
                        track.stop();
                    });
                }

                recorder = null;
            };

            webcamService.startOver = () => {
                startOver = true;
                webcamService.resetRecorder();
                webcamService.initRecorder();
            };

            /*
             * Measure the video duration
             * @param {Object} blob : video data
             */
            webcamService.getBlobDuration = (blob) => {
                const tempVideoEl = $document[0].createElement('video');

                const deferred = $q.defer();

                tempVideoEl.onloadedmetadata = () => {
                    // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=642012
                    if (tempVideoEl.duration === Infinity) {
                        tempVideoEl.currentTime = Number.MAX_SAFE_INTEGER;
                        tempVideoEl.ontimeupdate = () => {
                            tempVideoEl.ontimeupdate = null;
                            deferred.resolve(tempVideoEl.duration);
                            tempVideoEl.currentTime = 0;
                        };
                    } else {
                        deferred.resolve(tempVideoEl.duration);
                    }
                };

                tempVideoEl.src = $window.URL.createObjectURL(blob);

                return deferred.promise;
            };

            /*
             * Upload the video to our backend.
             * @param {Object} blob : video data
             */
            webcamService.uploadRecording = (blob, duration, id) => {
                logEventService.addEvent('Upload to ' + config.mediaUrl, 'Function');

                // reset recorded data
                recordedData = [];
                webcamService.resetRecorder();

                const url = config.mediaUrl + '/api/upload/video';
                const deferred = $q.defer();

                const fileName = webmMimeType ? 'blob.webm' : 'blob.mp4';

                const fileObject = new $window.File([blob], fileName, {
                    type: recorderParams.mimeType,
                });

                const formData = new $window.FormData();
                formData.append('file', fileObject);
                formData.append('id', config.user.id);
                if (duration) {
                    formData.append('video_length', duration);
                }

                let uploadPercentage = 0;
                httpProgress.post(url, formData, {
                    progress: function (e) {
                        if (e.lengthComputable) {
                            uploadPercentage = Math.floor(e.loaded * 100 / e.total);
                            $rootScope.$broadcast('recorder-uploading', uploadPercentage, id);
                            $rootScope.$apply();
                        }
                    },
                    success: function (response) {
                        if (response.success) {
                            // finished uploading video
                            response.video.video_type = 'webcam';
                            response.video.start_trim = 0;
                            response.video.video_thumb = response.video.video_thumbs[0];
                            $rootScope.$broadcast('recorder-upload-complete', response.video, id);
                            deferred.resolve();
                        } else $rootScope.$broadcast('recorder-upload-failed');

                        $rootScope.$apply();
                    },
                    error: function () {
                        $rootScope.$broadcast('recorder-upload-failed');
                        $rootScope.$apply();
                    },
                });

                return deferred.promise;
            };

            return webcamService;
        }]);
}());
